import { gql } from '@apollo/client';
import { workflowFragment } from 'api/fragments/workflows';

export const getRevisionsQuery = gql`
  query fetchJourneyRevisions(
    $id: Long!
    $workflowType: WorkflowType
    $offset: Int!
    $limit: Int!
  ) {
    workflow(id: $id, workflowType: $workflowType) {
      id
      revisions(offset: $offset, limit: $limit) {
        info {
          count
        }
        results {
          id
          enabledStatus
          createdAt
          creatorUser {
            id
            fullName
            avatarUrl
          }
        }
      }
    }
  }
`;

export const getSelectedRevisionQuery = gql`
  query fetchSelectedJourneyRevision($id: Long!) {
    journeyRevision(id: $id) {
      revisionId: id
      enabledStatus
      version {
        ...WorkflowFragment
      }
      revisionSummary {
        added {
          id
          liveWorkflowNodeId
          nodeDataJson
        }
        changed {
          id
          liveWorkflowNodeId
          nodeDataJson
        }
        deleted {
          id
          liveWorkflowNodeId
          nodeDataJson
        }
      }
    }
  }
  ${workflowFragment}
`;

export const revertJourneyMutation = gql`
  mutation revertJourney($id: Long!) {
    revertJourney(id: $id) {
      id
      workflowType
    }
  }
`;
